import { z } from "zod"

export const billingHistoryItemSchema = z.object({
  amount: z.string(),
  id: z.string(),
  created: z.string(),
  currency: z.string(),
  downloadPdf: z.string(),
  number: z.string(),
  status: z.string(),
  viewUrl: z.string(),
});

export const ITEM_PER_PAGE = 10